import type { UiState, IndexUiState, IndexWidget } from 'instantsearch.js';

// https://pinia.vuejs.org/core-concepts/#setup-stores
export const useAlgoliaStore = defineStore('woom-algolia', () => {
    const instantSearchInstance = ref<IndexWidget>();

    const setInstantSearchUiState = ({ query }: Partial<IndexUiState>) => {
        if (!instantSearchInstance.value) return;
        instantSearchInstance.value.setIndexUiState((uiState) => ({
            ...uiState,
            // We reset the page when the search state changes
            page: 1,
            query,
        }));
    };

    const setInstantSearchInstance = (instance: IndexWidget | undefined) => {
        instantSearchInstance.value = instance;
    };

    return {
        setInstantSearchUiState,
        setInstantSearchInstance,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useAlgoliaStore, import.meta.hot));
}
